import React from 'react'

const NotFoundPage: React.FC = () => {
    return <div>Not Found Page</div>
}

export default NotFoundPage
